import React from "react";
import { Row, Col, Collapse, CardBody } from "reactstrap";
import { formatDate } from "../../../Utils/format-date.js";
import { addClassName } from "../../../Utils/Add-ClassName.js";
import { calcPercentage } from "../../../Utils/calculate-progress.js";
import RenderModals from "../../Modals/modal";
import RenderinviteRespondantsModal from "../Sent/Invitation-Modal/Invite-respondants-modal";
import EditModal from "../Sent/Invitation-Modal/Edit-Modal/EditModal";
import DeleteModal from "../Sent/Invitation-Modal/Delete-Modal/DeleteModal";
import completed from "../../../../images/new-images/completed.png";
import editIcon from "../../../../images/new-images/edit-green.svg";
import editdisable from "../../../../images/new-images/edit-disable.svg";

import reminderIcon from "../../../../images/new-images/reminder-blue.svg";
import reminderDisableIcon from "../../../../images/new-images/reminder-disable.svg";
import MyinvitationsEmpty from "../Invitations-Empty";
import "./Sent-Tab.css";
const SentTab = (props) => {
  const editButtonControll = (
    getStatus,
    respondentEmail,
    respondentRelationship,
    uid,
    rid,
    groupId
  ) => {
    if (getStatus === "Completed" || getStatus === "In progress") {
      return <img style={{ cursor: "not-allowed" }} src={editdisable} />;
    } else {
      return (
        <div>
          <img
            onClick={() =>
              props.handleEditModal(
                respondentEmail,
                respondentRelationship,
                uid,
                rid,
                groupId
              )
            }
            src={editIcon}
          />
          <RenderModals
            assessmentModal={props.editModal}
            handleModalClose={props.handleModalClose}
            modalHeading="EDIT RELATIONSHIP"
          >
            <EditModal
              handleModalClose={props.handleModalClose}
              respondentEmail={props.respondentEmail}
              respondentRelationship={props.respondentRelationship}
              assessmentUserId={props.assessmentUserId}
              accessorGroupId={props.accessorGroupId}
              relationShipId={props.relationShipId}
              dropDownOptions={props.dropDownOptions}
              handleDropdownOptions={props.handleDropdownOptions}
              sentRespondantsId={props.sentRespondantsId}
              sentRespondantsFilteredId={props.sentRespondantsFilteredId}
            />
          </RenderModals>
        </div>
      );
    }
  };

  const reminderButtonControll = (
    getStatus,
    userId,
    respondantsId,
    respondantEmail
  ) => {
    if (getStatus === "Completed" || getStatus === "In progress") {
      return (
        <img style={{ cursor: "not-allowed" }} src={reminderDisableIcon} />
      );
    } else {
      return (
        <img
          src={reminderIcon}
          onClick={() =>
            props.handleReminder(userId, respondantsId, respondantEmail)
          }
        />
      );
    }
  };

  return (
    <React.Fragment>
      {props.sentRespondants.length == 0 ||
        props.getRespondantStatus.length == 0 ? (
        <MyinvitationsEmpty />
      ) : (
        <React.Fragment>


          <RenderModals
            assessmentModal={props.respondentInvitationsModal}
            handleModalClose={props.handleModalClose}
            modalHeading="INVITE RESPONDENT"
          >
            <RenderinviteRespondantsModal
              inputFields={props.inputFields}
              handleInputFields={props.handleInputFields}
              dropDownOptions={props.dropDownOptions}
              handleMultipleEmail={props.handleMultipleEmail}
              isChecked={props.isChecked}
              isDisabled={props.isDisabled}
              handleModalFormSubmit={props.handleModalFormSubmit}
              handleModalClose={props.handleModalClose}
            />
          </RenderModals>
          {props.sentRespondants.map((details, index) => {
            return (
              <React.Fragment key={index}>
                {details.respondents.map((respondentData, index) => {
                  let referenceId = respondentData.respondent__id + respondentData.user_assessment__id + respondentData.id
                  return (
                    <div key={index} className="resopnsive-sent-tab">
                      <Row onClick={() => props.toggleCollapse(referenceId)}>
                        {respondentData.respondent__full_name == null || respondentData.respondent__full_name === '' ? (
                          <p className="head-name">{respondentData.respondent__email}<span style={{ textTransform: "lowercase", marginRight: '5px' }}>'s</span>  {details.instrument__instrument_name}</p>
                        ) : (
                          <p className="head-name">{respondentData.respondent__full_name}<span style={{ textTransform: "lowercase", marginRight: '5px' }}>'s</span>  {details.instrument__instrument_name}</p>
                        )}
                        <i
                          className={props.collapseID === referenceId ? "fas fa-angle-up" : "fa fa-angle-down"}
                          aria-hidden="true"
                        />
                      </Row>
                      <hr />
                      <Collapse isOpen={props.collapseID === referenceId}>
                        <CardBody>
                          {respondentData.respondent__full_name == null || respondentData.respondent__full_name === '' ? ('') : (
                            <Row>
                              <Col className="title">Email</Col>
                              <Col className="info">
                                {respondentData.respondent__email}
                              </Col>
                            </Row>
                          )}
                          <Row>
                            <Col className="title">Relationship</Col>
                            <Col className="info">
                              {respondentData.assessor_group__assessor_name}
                            </Col>
                          </Row>
                          <Row>
                            <Col className="title">Date of Expiry</Col>
                            <Col className="info">
                              {formatDate(
                                respondentData.user_assessment__expiry_date
                              )}
                            </Col>
                          </Row>
                          <Row>
                            <Col className="title">Status</Col>
                            <Col>
                              {respondentData.assessment_status__status_name ===
                                "In progress" ? (
                                <div
                                  style={{ display: "flex" }}
                                  className={
                                    "assessment-status-text " +
                                    addClassName(
                                      respondentData.assessment_status__status_name
                                    )
                                  }
                                >
                                  {respondentData.assessment_status__status_name}
                                  {calcPercentage(
                                  respondentData.user_assessment__assessment_number_count,
                                  respondentData.respondent_completed_count
                                )}
                                </div>
                              ) : respondentData.assessment_status__status_name ===
                                "Completed" ? (
                                <div
                                  className={
                                    "assessment-status-text " +
                                    addClassName(
                                      respondentData.assessment_status__status_name
                                    )
                                  }
                                >
                                  {respondentData.assessment_status__status_name}
                                  <img src={completed} alt="Completed Image" />
                                </div>
                              ) : (
                                <div
                                  className={
                                    "assessment-status-text " +
                                    addClassName(
                                      respondentData.assessment_status__status_name
                                    )
                                  }
                                >
                                  {respondentData.assessment_status__status_name}
                                </div>
                              )}
                            </Col>
                          </Row>
                          <hr />
                          <Row className="actions">
                            <div className="edit-Icon">
                              {editButtonControll(
                                respondentData.assessment_status__status_name,
                                respondentData.respondent__email,
                                respondentData.assessor_group__assessor_name
                              )}
                            </div>

                            <RenderModals
                              assessmentModal={props.deleteModal}
                              handleModalClose={props.handleModalClose}
                              modalHeading="DELETE RESPONDENT"
                            >
                              <DeleteModal
                                handleModalClose={props.handleModalClose}
                                respondentEmail={props.respondentEmail}
                              />
                            </RenderModals>
                            <div className="reminder-Icon">
                              {reminderButtonControll(
                                respondentData.assessment_status__status_name,
                                respondentData.user_assessment__id,
                                respondentData.respondent__email,
                                respondentData.respondent__id
                              )}
                            </div>
                          </Row>
                        </CardBody>
                      </Collapse>
                    </div>
                  )
                })}
              </React.Fragment>
            );
          })}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default SentTab;



// WEBPACK FOOTER //
// ./src/new/Components/Invitations/Responsive/Sent-Tab.jsx